import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import EdVueTools from "ed-vue-tools"
import "ed-vue-tools/dist/ed-vue-tools.css"
// import repository from '../lansa';

Vue.config.productionTip = false

Vue.use(EdVueTools, {
    envMode: process.env.NODE_ENV,

    // lansa: {},
})

new Vue({
    router,
    store,
    render: function (h) {
        return h(App)
    },
}).$mount("#app")
